export default __webpack_public_path__ + "static/media/closeBlack.8cd578b6.svg";